import { render } from "./BillingsList.vue?vue&type=template&id=72e7ff21"
import script from "./BillingsList.vue?vue&type=script&lang=js"
export * from "./BillingsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__